'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    quote: 'Royal Prime Labels helped us maintain consistent packaging quality during large scale production.',
    author: 'FMCG Brand',
    location: 'Delhi NCR'
  },
  {
    quote: 'Their label finishing and dispatch support helped improve our packaging workflow.',
    author: 'Cosmetic Packaging Client',
    location: 'Mumbai'
  },
  {
    quote: 'Reliable print consistency and smooth production coordination.',
    author: 'Pharmaceutical Company',
    location: 'Baddi, HP'
  }
];

const AboutTestimonials = () => {
  return (
    <section className="w-full bg-[#F8FAFC] py-16 md:py-24" aria-labelledby="testimonials-heading">
      <div className="mx-auto w-full max-w-[1240px] px-4 sm:px-6 md:px-8">
        <header className="mb-12 md:mb-16 text-center max-w-[800px] mx-auto">
          <span className="text-blue-600 font-bold tracking-[3px] uppercase text-xs mb-3 block">Client Success</span>
          <h2
            id="testimonials-heading"
            className="text-[#0F172A] font-extrabold tracking-tight text-[clamp(28px,4vw,38px)] leading-[1.2]"
          >
            What Businesses Say About Us
          </h2>
          <p className="mt-4 text-slate-600 text-[16px] md:text-[17px] leading-relaxed">
            Discover how we collaborate with brands across India to support stable quality, smooth workflows, and reliable label delivery.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((item, idx) => (
            <motion.article
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ delay: idx * 0.1, duration: 0.5 }}
              className="bg-white p-8 rounded-3xl border border-slate-200 shadow-[0_4px_12px_rgba(0,0,0,0.02)] relative flex flex-col justify-between group hover:shadow-[0_12px_30px_rgba(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-300"
            >
              {/* Decorative quotation mark */}
              <Quote className="absolute top-6 right-8 h-10 w-10 text-slate-100 group-hover:text-blue-50 transition-colors duration-300 pointer-events-none" />

              <div className="flex flex-col gap-5 z-10">
                {/* 5 Stars */}
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-[#C9A84C] text-[#C9A84C]" />
                  ))}
                </div>

                {/* Quote Content */}
                <p className="text-slate-700 text-[15px] md:text-[16px] leading-relaxed italic">
                  “{item.quote}”
                </p>
              </div>

              {/* Author Info */}
              <div className="mt-8 pt-4 border-t border-slate-100 flex flex-col gap-0.5">
                <h4 className="text-slate-900 font-bold text-[15px]">
                  {item.author}
                </h4>
                <p className="text-slate-400 text-[12px] font-semibold tracking-wider uppercase">
                  {item.location}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutTestimonials;
